import React from 'react';
import Avatar from '../avatar';
import CommentText from './CommentText';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';

export default class CommentItem extends Component {
    render() {
        const displayName = 'comment';
        const {
            children, avatarSrc, avatarGender, avatarClick,
            avatarName, avatarNameExtra, headerLeft,
            headerRight, at, text, quote, bottomLeft,
            bottomRight, inner, border, avatarChildren, subClassName } = this.props;

        const modifierClassList = {
            [bem(displayName, 'item', 'inner')]: inner,
            [bem(displayName, 'item', 'last')]: !border,
        };
        // console.log('======avatarChildren===', avatarChildren);

        return (
            <div
                style={this.style()}
                className={this.className(bem(displayName, 'item'), modifierClassList) + subClassName}
                {...getDataAttr(this.props)}>
                <Avatar
                    className={bem(displayName, 'avatar')}
                    src={avatarSrc}
                    gender={avatarGender}
                    size="md"
                    children={avatarChildren}
                    onClick={avatarClick}
                />
                <div className={bem(displayName, 'content')}>
                    <div className={bem(displayName, 'header')}>
                        <div className={bem(displayName, 'header-left')}>
                            <div className={bem(displayName, 'namebox')}>
                                <span className={bem(displayName, 'name')} onClick={avatarClick}>{avatarName}</span>
                                {avatarNameExtra}
                            </div>
                            {headerLeft}
                        </div>
                        {!!headerRight && <div className={bem(displayName, 'header-right')}>
                            {headerRight}
                        </div>}
                    </div>
                    <div className={bem(displayName, 'body')}>
                        {text && <CommentText at={at}>{text}</CommentText>}
                        {!!quote && <div className={this.classNames(bem(displayName, 'quote'), typeof quote === 'string' ? '' : bem(displayName, 'quote', 'extra'))}>{quote}</div>}
                    </div>
                    {(bottomLeft || bottomRight) && <div className={bem(displayName, 'bottom')}>
                        <div className={bem(displayName, 'bottom-left')}>
                            {bottomLeft}
                        </div>
                        {!!bottomRight && <div className={bem(displayName, 'bottom-right')}>
                            {bottomRight}
                        </div>}
                    </div>}
                    {children}
                </div>
            </div>
        );
    }
}

CommentItem.defaultProps = {
    children: null,
    avatarSrc: null,
    avatarGender: null,
    avatarClick: null,
    avatarName: '',
    avatarNameExtra: null,
    headerLeft: null,
    headerRight: null,
    at: null,
    text: null,
    quote: null,
    bottomLeft: null,
    bottomRight: null,
    inner: false,
    border: true,
    avatarChildren: null,
};

CommentItem.propTypes = {
    // @INTRO children
    children: PropTypes.node,
    // @INTRO 图片url
    avatarSrc: PropTypes.string,
    // @INTRO 头像性别标识
    avatarGender: PropTypes.oneOf([
        'male',
        'female',
    ]),
    // @INTRO 头像点击事件
    avatarClick: PropTypes.func,
    // @INTRO 用户name
    avatarName: PropTypes.string,
    // @INTRO 用户name右侧区域内容： 如level
    avatarNameExtra: PropTypes.node,
    // @INTRO 用户name下方区域内容： 如rate
    headerLeft: PropTypes.node,
    // @INTRO 用户name右侧操作区域内容： 如点赞
    headerRight: PropTypes.node,
    // @INTRO 回复人名
    at: PropTypes.string,
    // @INTRO 文本
    text: PropTypes.node,
    // @INTRO 引用
    quote: PropTypes.node,
    // @INTRO 底部左侧元素
    bottomLeft: PropTypes.node,
    // @INTRO 底部右侧元素
    bottomRight: PropTypes.node,
    // @INTRO 是否带分割线，最后一条列表不带
    border: PropTypes.bool,
    // @INTRO 是否是楼中楼内楼
    inner: PropTypes.bool,
    // @INTRO avatar children
    avatarChildren: PropTypes.node,
};
